import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../hooks'
import { useCaseDashboard } from './use-case-management-dashboard'
import {
  DashboardBody,
  DashboardError,
  DashboardHeader,
  DashboardModals,
} from './CaseManagementDashboard.parts'

interface CaseManagementDashboardProps {
  onOpenCase?: (caseId: string) => void
  onStartPreview?: () => void
  embedded?: boolean
}

export function CaseManagementDashboard({
  onOpenCase,
  onStartPreview,
  embedded = false,
}: CaseManagementDashboardProps): ReactElement {
  const { user } = useAuth()
  const { t } = useTranslation(['cases', 'common'])
  const dash = useCaseDashboard()
  const userName = user?.displayName ?? user?.username
  const errorMessage = dash.casesError ?? dash.mutationError

  return (
    <div className={embedded ? '' : 'min-h-screen'}>
      <DashboardHeader dash={dash} embedded={embedded} onStartPreview={onStartPreview} />
      {errorMessage && <DashboardError message={errorMessage} />}
      <DashboardBody
        dash={dash}
        userName={userName}
        onOpenCase={onOpenCase}
        loadingLabel={t('management.loadingCases')}
      />
      <DashboardModals dash={dash} />
    </div>
  )
}
